import {ApplicationState} from "@/api-client";
import {ls} from "@/CultureService";

export default function translateApplicationState(state: ApplicationState): string {
    switch (state) {
        case ApplicationState.ApplicationSubmitted:
            return ls.Applications_ApplicationState_Submitted;
        case ApplicationState.ApplicationNotSubmitted:
            return ls.Applications_ApplicationState_NotSubmitted;
        case ApplicationState.PendingApplication:
            return ls.Applications_ApplicationState_InProcessing;
        case ApplicationState.ApplicationRejected:
            return ls.Applications_ApplicationState_Rejected;
        case ApplicationState.DocumentIssued:
            return ls.Applications_ApplicationState_DocumentIssued;
        default:
            return state;
    }
}